import posthog from 'posthog-js';
import { defineNuxtPlugin } from '#app';

export default defineNuxtPlugin((nuxtApp) => {
  const runtimeConfig = useRuntimeConfig();
  const posthogClient =
    runtimeConfig.public.posthogPublicKey &&
    !['localhost', '127.0.0.1'].includes(window.location.hostname)
      ? posthog.init(runtimeConfig.public.posthogPublicKey, {
        api_host: runtimeConfig.public.posthogHost,
        defaults: runtimeConfig.public.posthogDefaults,
        person_profiles: 'identified_only', // or 'always' to create profiles for anonymous users as well
        loaded: (posthog) => {
          if (import.meta.env.MODE === 'development') posthog.debug();
        },
      })
      : null;

  return {
    provide: {
      posthog: () => posthogClient,
    },
  };
});
